var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
import AsyncStatus from "../../utils/async";
import updateAgencyName from "../../api/mutations/updateAgencyName";
import mixins from "vue-typed-mixins";
import NotificationsMixin from "../ui/NotificationsMixin";
import { rethrowPossibleApolloErrorAsUserMessage } from "../../api/apolloErrorToUserMessage";
export default mixins(NotificationsMixin).extend({
    props: {
        agent: {
            type: Object,
            required: true,
        },
    },
    fragments: {
        agent: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      fragment UpdateAgencyNameForm_agent on Agent {\n        id\n        agencyName\n      }\n    "], ["\n      fragment UpdateAgencyNameForm_agent on Agent {\n        id\n        agencyName\n      }\n    "]))),
    },
    data: function () {
        return {
            form: {
                agencyName: this.agent.agencyName,
            },
            status: new AsyncStatus(),
        };
    },
    methods: {
        onSubmit: function () {
            var _this = this;
            this.$validator.validate().then(function (valid) {
                if (!valid) {
                    return;
                }
                _this.status
                    .run(_this.$apollo
                    .mutate(updateAgencyName(_this.agent.id, _this.form))
                    .catch(rethrowPossibleApolloErrorAsUserMessage))
                    .then(function () { return _this.displaySuccessMessage(_this.$t("Name updated")); });
            });
        },
    },
});
var templateObject_1;
